import { Icon } from '@pickleballinc/ui/components/ui/icon';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import AvailablePlayersArea from '@/components/molecules/AvailablePlayersArea';
import DroppableArea from '@/components/molecules/DroppableArea';
import { TeamLeagueTeamsInfo } from '@/entities/TeamLeagueTeamsInfo';
import { TeamPlayerInfo } from '@/lib/types';
import { useTeamLeagueTeamPlayersQuery } from '@/hooks/player-move/useTeamLeagueTeamPlayersQuery';
import PlayerCard from '@/app/team-leagues/[teamLeagueId]/(secure)/teams/[teamId]/player-moves/add-player/_components/player-card';

interface StepThreeProps {
	selectedTeam: TeamLeagueTeamsInfo;
	otherTeamDropped: TeamPlayerInfo[];
	setOtherTeamDropped: Dispatch<SetStateAction<TeamPlayerInfo[]>>;
}

export function StepThree({ selectedTeam, otherTeamDropped, setOtherTeamDropped }: StepThreeProps) {
	const [availablePlayers, setAvailablePlayers] = useState<TeamPlayerInfo[]>([]);

	const { data, isLoading } = useTeamLeagueTeamPlayersQuery(selectedTeam.uuid);

	useEffect(() => {
		if (data?.data) {
			const filteredPlayers = data.data.filter((player) => !otherTeamDropped.some((p) => p.uuid === player.uuid));
			setAvailablePlayers(filteredPlayers);
		}
	}, [data, otherTeamDropped]);

	const handleDrop = (player: TeamPlayerInfo) => {
		setAvailablePlayers((prev) => prev.filter((p) => p.uuid !== player.uuid));
		if (!otherTeamDropped.some((p) => p.uuid === player.uuid)) {
			setOtherTeamDropped((prev) => [...prev, player]);
		}
	};

	const handleReturn = (player: TeamPlayerInfo) => {
		if (!availablePlayers.some((p) => p.uuid === player.uuid)) {
			setAvailablePlayers((prev) => [...prev, player]);
		}
		setOtherTeamDropped((prev) => prev.filter((p) => p.uuid !== player.uuid));
	};

	const handleCheckbox = (player: TeamPlayerInfo, checked: boolean) => {
		if (checked) {
			setAvailablePlayers((prev) => prev.filter((p) => p.uuid !== player.uuid));
			setOtherTeamDropped((prev) => [...prev, player]);
		} else {
			setAvailablePlayers((prev) => [...prev, player]);
			setOtherTeamDropped((prev) => prev.filter((p) => p.uuid !== player.uuid));
		}
	};

	return (
		<>
			<div className="hidden gap-1 lg:flex">
				<AvailablePlayersArea availablePlayers={availablePlayers} onDrop={handleReturn} isLoading={isLoading} />
				<Icon glyph="arrow-left-orange" className="rotate-180" />
				<DroppableArea droppedPlayers={otherTeamDropped} onDrop={handleDrop} />
			</div>
			<div className="lg:hidden">
				{availablePlayers.map((player) => (
					<PlayerCard
						key={player.uuid}
						name={player.firstName + ' ' + player.lastName}
						phone={player.phone}
						duprDoubles={player.ratingDoubles}
						duprSingles={player.ratingSingles}
						image={player.photo}
						onCheck={(checked: boolean) => handleCheckbox(player, checked)}
					/>
				))}
			</div>
		</>
	);
}
